import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import BCT from './BCT';
import Select from '../Components/Select';


import { getPathwayBarriers } from '../../../Actions/Dashboard/pathwaybarriers';

class HabitHacker extends React.Component {
  state = {
    selectedbarrier: 0,
    bcts: [],
  }

  componentDidMount() {
    this.update = this.update.bind(this);
    this.props.dispatch(getPathwayBarriers(this.props.pathway));
  }

  componentDidUpdate(prevProps) {
    if (this.props.pathway !== prevProps.pathway) {
      this.props.dispatch(getPathwayBarriers(this.props.pathway));
    }

    if (!this.state.selectedbarrier && this.props.plan.length) {
      this.setState({ selectedbarrier: this.props.plan[0], bcts: this.props.plan[0].bcts });
    }
  }

  update(str) {
    let selectedBarrier = {};
    this.props.plan && this.props.plan.forEach((plan) => {
      if (plan.id.toString() === str) selectedBarrier = plan;
      return null;
    });

    this.setState({ bcts: selectedBarrier.bcts, selectedbarrier: selectedBarrier });
  }

  pathwayText = () => {
    switch (this.props.pathway) {
      case 'weight':
        return 'lose weight';
      case 'activity':
        return 'get active';
      case 'smoking':
        return 'stop smoking';
      case 'alcohol':
        return 'drink less';
      default:
        return '';
    }
  }

  render() {
    return (
      <div>
        <div className="storyblock">
          <div className="header">
            <p>I want to <span className="pathway">{this.pathwayText()}</span></p>
            <p>but
              <Select
                defaultValue={this.state.selectedbarrier.id}
                onChange={this.update}
                options={this.props.plan}
              />
            </p>
            <p>Use these tools to hack that habit:</p>
          </div>

          <div className="comb" data-pathway={this.props.pathway}>
            <ul className="comb_challenges comb_challenges__hacks">
              { this.state.bcts && this.state.bcts.map(bct => <BCT data={bct} key={bct.id} barrier={this.state.selectedbarrier} action="addtoplan" />) }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

HabitHacker.propTypes = {
  plan: PropTypes.array.isRequired,
  pathway: PropTypes.string.isRequired,
};

export default connect(state => ({
  pathway: state.pathway,
  plan: state.pathwaybarriers || [],
}), dispatch => ({ dispatch }))(HabitHacker);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/HabitHacker.jsx